import React from 'react';
import { Redirect, Route } from 'react-router-dom';

export default ({ component: Component, props: cProps, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      if (!cProps.isLoggedIn) {
        return (
          <Redirect
            to={{
              pathname: '/sign_in',
              state: { from: props.location },
            }}
          />
        );
      } else {
        if (cProps.user && cProps.user.subscribed) {
          return <Component {...props} {...cProps} />;
        } else {
          return (
            <Redirect
              to={{
                pathname: '/billing',
                state: { from: props.location },
              }}
            />
          );
        }
      }
    }}
  />
);



// WEBPACK FOOTER //
// ./src/helpers/RequireSubscription.js